import React from "react";

const state = {
    notify: ()=>{}
};

const NotifyContext = React.createContext(state.notify);



export default NotifyContext;
